import { Link } from 'react-router-dom';
import { Eye, UserPlus, History, LayoutDashboard, PhoneCall } from 'lucide-react';
import { RecentCallsPeek } from './RecentCallsPeek';

const LINKS = [
  { to: '/admin', icon: UserPlus, title: 'Invite & manage reps', desc: 'Add sales reps — they start the calls', testid: 'viewonly-link-admin' },
  { to: '/history', icon: History, title: 'Team call history', desc: 'Review calls, scores and summaries', testid: 'viewonly-link-history' },
  { to: '/admin', icon: LayoutDashboard, title: 'Admin panel', desc: 'Frameworks, products and team analytics', testid: 'viewonly-link-panel' },
];

export const AdminViewOnlyPanel = ({ role = 'admin' }) => (
  <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-start" data-testid="admin-view-only-panel">
    <div className="lg:col-span-7 xl:col-span-8 flex flex-col gap-6">
      <div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-zinc-900" style={{ fontFamily: 'var(--font-heading)' }}>
          Team overview
        </h1>
        <p className="text-zinc-500 mt-2">
          Monitor your team&apos;s calls, coaching and qualification performance
        </p>
      </div>

      <div className="bg-white border border-zinc-200 rounded-2xl p-6 sm:p-8 shadow-sm">
        <div className="flex items-start gap-4">
          <div className="w-11 h-11 rounded-xl bg-brand-muted flex items-center justify-center shrink-0">
            <Eye className="w-5 h-5 text-brand-primary" />
          </div>
          <div>
            <p className="font-semibold text-zinc-900">
              {role === 'manager' ? 'Manager' : 'Admin'} seats are view-only
            </p>
            <p className="text-sm text-zinc-500 mt-1 leading-relaxed">
              Live calls are started by your sales reps from their own logins — PipeGuide coaches them in real time
              while you track scores, summaries and team analytics from here. Your organisation&apos;s call tokens are
              consumed by reps when their calls complete.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-6">
          {LINKS.map((l) => (
            <Link
              key={l.testid}
              to={l.to}
              className="border border-zinc-200 rounded-xl p-4 hover:border-brand-accent hover:bg-brand-muted/40 transition-colors"
              data-testid={l.testid}
            >
              <l.icon className="w-5 h-5 text-brand-primary mb-2" />
              <p className="text-sm font-semibold text-zinc-800">{l.title}</p>
              <p className="text-xs text-zinc-500 mt-0.5">{l.desc}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>

    <div className="lg:col-span-5 xl:col-span-4 flex flex-col gap-4">
      <div className="bg-[#FAFAFA] border border-zinc-200 rounded-2xl p-6">
        <div className="flex items-center gap-2 mb-3">
          <PhoneCall className="w-4 h-4 text-brand-primary" />
          <span className="text-xs font-bold uppercase tracking-widest text-zinc-500">How your reps start a call</span>
        </div>
        <ol className="space-y-3 text-sm text-zinc-600 leading-relaxed list-none">
          <li>1. Rep signs in and opens the New Call screen</li>
          <li>2. Pastes a meeting link (or uses the microphone for in-person)</li>
          <li>3. PipeGuide scores the conversation live and suggests probing questions</li>
          <li>4. You see the summary and score here the moment the call ends</li>
        </ol>
      </div>
      <RecentCallsPeek teamView />
    </div>
  </div>
);
